import { useEffect, useState } from "react";
import {
  ChildrenStoreData,
  EyengagePost,
  PollOption,
} from "src/shared/types/src";
import { useAppDispatch, useAppSelector } from "../../../services/store";
import { AxiosError } from "axios";
import {
  getCurrentChild,
} from "src/shared/redux-state/src";
import { patchEyengagePollSelection } from "src/shared/services/src";
import { EyengageActions } from "src/shared/redux-state/src/lib/eyengage/EyengageSlice";
import { GoCheckCircleFill } from "react-icons/go";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { EYENGAGE_POST_TYPES } from "src/shared/config/src";

export default function PostPollContainer({
  postData,
}: {
  postData: EyengagePost;
}) {
  const dispatch = useAppDispatch();

  const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);
  // const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  // string determines the option id and string (1/0) determines if api is loading for this option
  const [selectedOptionMap, setSelectedOptionMap] = useState<
    Record<string, string>
  >({});
  const [loadingForOptions, setLoadingForOptions] = useState<string[]>([]);

  useEffect(() => {
    const selectedOptions = {} as Record<string, string>;
    if (postData?.poll?.options) {
      postData.poll.options.forEach((option) => {
        if (option.selected) {
          selectedOptions[option.id] = "1";
        }
      });
      setSelectedOptionMap(selectedOptions);
    }
  }, [postData.poll]);

  const handleSelectPollOption = async (optionId: string) => {
    if (loadingForOptions.length) return;
    if (postData.type === EYENGAGE_POST_TYPES.EVENT && !postData?.eventMeta?.isRsvpOpen) {
      toast.error('You can no longer RSVP to this event because the RSVP deadline has passed.', { autoClose: 5000 });
      return;
    }

    let selectedOptions = Object.assign({}, selectedOptionMap);

    if (selectedOptions[optionId]) {
      delete selectedOptions[optionId];
    } else {
      if (!postData.poll.is_multiselect) {
        selectedOptions = {};
      }
      selectedOptions[optionId] = "1";
    }

    try {
      setLoadingForOptions([...loadingForOptions, optionId]);
      const response = await patchEyengagePollSelection({
        child: currentChild,
        postId: postData.id,
        selectedOptions: Object.keys(selectedOptions),
      });
      console.log("response from api for poll is : ", response);
      if (response && Object.keys(response).length) {
        setSelectedOptionMap(selectedOptions);
        // update the post in the redux list for poll data
        await dispatch(
          EyengageActions.updatePollDataInPostById({
            postId: postData.id,
            updatedPoll: response?.post?.poll,
          })
        );
      } else {
        setSelectedOptionMap({});
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        const apiError = error as AxiosError;
        if (apiError && apiError.response && apiError.response.status === 404) {
          const { errors } = error.response?.data;
          toast.error(errors.join(", "), { autoClose: 5000 });
        }
      }
    } finally {
      setLoadingForOptions(loadingForOptions.filter((id) => id !== optionId));
    }
  };

  return (
    <div className="mg-t-15">
      {postData && postData.poll ? (
        <>
          {postData.poll.is_multiselect ? (
            <h2 className="mg-b-10 fs-12 text-black fw-semibold">
              Select multiple options:
            </h2>
          ) : null}
          <div className="poll-option-Item-wrap">
            {postData.poll &&
                postData.poll.options &&
                postData.poll.options.map((option: PollOption, index: number) => (
                
                    <div
                    onClick={() => handleSelectPollOption(option.id)}
                    className="poll-option-item cursor-pointer" key={index} 
                    >
                        <div className={`poll-option  ${!loadingForOptions.includes(option.id) &&
                            selectedOptionMap[option.id]? "checked" : ""}`}>
                            <span className="fs-12 text-black">{option.name}</span>
                            {!loadingForOptions.includes(option.id) &&
                            selectedOptionMap[option.id] ? (
                            <div className="poll-option-icon position-absolute">
                                <GoCheckCircleFill size={20} />
                            </div>
                            ) : null}
                            {loadingForOptions.includes(option.id) ? (
                            <div className="position-absolute top-50 end-10 translate-middle">
                                <Spinner style={{ width: "14px", height: "14px" }} />
                            </div>
                            ) : null}
                        </div>
                    </div>
                ))}
          </div>
        </>
      ) : null}
    </div>
  );
}
